const common = {
  nav: {
    listings:      "Listings",
    international: "International",
    blog:          "Blog",
    about:         "About",
    contact:       "Contact",
    cta:           "Get in touch",
  },
  badge: {
    rent: "For rent",
    sale: "For sale",
  },
  btn: {
    whatsapp:    "WhatsApp agent",
    telegram:    "Telegram",
    viewProp:    "View property →",
    browseList:  "Browse listings",
    contactAgent:"Contact agent",
    sendMsg:     "Send message",
  },
  footer: {
    tagline:      "Your trusted partner in premium Dubai & UAE real estate.",
    nav:          "Navigation",
    properties:   "Properties",
    contact:      "Contact",
    forSale:      "For sale",
    forRent:      "For rent",
    uae:          "UAE",
    international:"International",
  },
  notFound: "Property not found",
};

export default common;
